// src/app/queryClient.js
import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5,       // 5 min
            cacheTime: 1000 * 60,      // 1 min
            refetchOnWindowFocus: false,
        },
        mutations: {
            onError: (err) => {
                // e.g. show a toast:
                console.error('Mutation error', err);
            },
        },
    },
});

export default queryClient;
